import type { TFunction } from "i18next";
import type { Ereignis } from "@iso27001/shared";

/** The event's classification flags as badges, for the list and the read-only dialog. */
export const classBadges = (e: Ereignis, t: TFunction): { label: string; color: string }[] => {
  const out: { label: string; color: string }[] = [];
  if (e.isEreignis) out.push({ label: t("ereignisse.classification.ereignis"), color: "blue" });
  if (e.isSecurityEvent) out.push({ label: t("ereignisse.classification.badge.securityEvent"), color: "yellow" });
  if (e.isSecurityIncident) out.push({ label: t("ereignisse.classification.badge.securityIncident"), color: "red" });
  if (e.isDataProtectionIncident) out.push({ label: t("ereignisse.classification.badge.dataProtectionIncident"), color: "grape" });
  if (e.isNonconformity) out.push({ label: t("ereignisse.classification.nonconformity"), color: "orange" });
  return out;
};
